import React from 'react';
import './Become.css';
import Speaker from "../../img/Become/speaker.svg";
import Sponsor from "../../img/Become/sponsor.svg";
import Moderator from "../../img/Become/moderator.svg";

const Become = () => {
    const state = {
        Become_item: [
            {
                img: Speaker,
                title: 'Become a speaker',
                href: 'https://docs.google.com/forms/d/1RaNnOUycuZwwc1wnaPkgtTQMBnHfBQnJziArTUKXH0Y',
            },
            {
                img: Moderator,
                title: 'Become a moderator',
                href: 'https://docs.google.com/forms/d/e/1FAIpQLSeuZZ1Jh_c1uO9feC3sT00s736R_eULGQVOPifFfK8SPGz6Mw/viewform',
            },
            {
                img: Sponsor,
                title: 'Become a sponsor',
                href: 'https://docs.google.com/forms/d/1sostKl862SzlpTeo_H02tSO1wnMxk3x3b1oVm7u2A5U',
                sponsorship: 'https://drive.google.com/file/d/1y0QoueqFDljx0X0u4QnxsKOAKV51232n/view?usp=sharing',
            },
        ],
    };

    const renderBecome_item = (item, i) => {
        return (
            <div className="become_item" key={`Numbers_item-${i}`}>
                <img className="become_img" src={item.img} alt="Become image" />
                <p className='become_title'>{item.title}</p>
                <a className='become_button button' target='_blank' rel='noreffered' href={item.href}>Apply</a>
                {item.sponsorship && <a className='button become_button become_button--sponsorship' target='_blank' rel='noreffered' href={item.sponsorship}>
                    <svg className='become_button-prosp_img' width="25" height="29" viewBox="0 0 25 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22.7986 22.2163V26.2163H2.79858V22.2163H0.798584V26.2163C0.798584 26.7467 1.0093 27.2554 1.38437 27.6305C1.75944 28.0056 2.26815 28.2163 2.79858 28.2163H22.7986C23.329 28.2163 23.8377 28.0056 24.2128 27.6305C24.5879 27.2554 24.7986 26.7467 24.7986 26.2163V22.2163H22.7986ZM22.7986 12.2163L21.3886 10.8063L13.7986 18.3863V0.216309H11.7986V18.3863L4.20858 10.8063L2.79858 12.2163L12.7986 22.2163L22.7986 12.2163Z" fill="#767676" />
                    </svg>
                    Prospectus
                </a>}
            </div>
        );
    };

    return (
        <div className="become" id='become'>
            <div className="container">
                {state.Become_item.map((item, i) => renderBecome_item(item, i))}
            </div>
        </div>
    );
};

export default Become;